import React from 'react';
import { SvgIcon } from '@mui/material';

function SvgFoxtonsOutlined(props) {
  return (
    <SvgIcon {...props} title="FoxtonsOutlined">
      <svg
        viewBox="0 0 20 20"
        fill="#000"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
          d="M9.606 16.097v-4.821h1.776l.85-2.39H9.606v-2.18h2.59l.998-2.222H7.387v11.613h2.22Z"
          fill="#017163"
        />
        <path
          d="M18.227 10a8.227 8.227 0 1 1-16.454 0 8.227 8.227 0 0 1 16.454 0ZM10 19.1A9.1 9.1 0 1 0 10 .9a9.1 9.1 0 0 0 0 18.2Z"
          fill="#017163"
          stroke="#017163"
          strokeWidth={0.2}
        />
      </svg>
    </SvgIcon>
  );
}

export default SvgFoxtonsOutlined;
